import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { Constants } from "../../../../helpers/app.constants";
import { DomSanitizer, SafeHtml, SafeResourceUrl } from "@angular/platform-browser";
import { PageContentDetailModel } from "../../../../models";
import { SharedModule } from '../../../shared/shared.module';
import { PlanAccessService } from "src/services";

@Component({
    standalone: true,
    imports: [SharedModule],
 selector:'app-help',
 templateUrl:'./help.component.html',
 styleUrls: ['./help.component.scss']
})

export class HelpComponent implements OnInit, OnChanges{
    @Input() model: any;
    @Output() add: EventEmitter<any> = new EventEmitter<any>();
    helpVideo: SafeHtml;
    isVisible = false;

    get constants() { return Constants; }

    constructor(
        private sanitizer: DomSanitizer,
        public planAccess: PlanAccessService
    ) {}

    ngOnChanges() {
        this.helpVideo = this.sanitizeHtml(this.model.content);
    }

    ngOnInit(): void {
        this.helpVideo = this.sanitizeHtml(this.model.content);
    }

    sanitizeHtml(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustHtml(url);
    }

    showModal(): void {
        this.isVisible = true;
    }

    closeModal(): void {
        this.isVisible = false;
    }
}
